var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7397 4.31601C16.0868 4.66315 16.0868 5.22596 15.7397 5.57309L8.62854 12.6842C8.28141 13.0313 7.71859 13.0313 7.37146 12.6842L0.260348 5.57309C-0.0867844 5.22596 -0.0867844 4.66315 0.260348 4.31601C0.607483 3.96888 1.17029 3.96888 1.51743 4.31601L8 10.7986L14.4826 4.31601C14.8297 3.96888 15.3925 3.96888 15.7397 4.31601Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand_icon.573daa7947a49d6c7be5df314361d115.svg";
export { ForwardRef as ReactComponent };